import React from "react";
import PropTypes from "prop-types";

import Skeleton from "@material-ui/lab/Skeleton";
import { Checkbox } from "semantic-ui-react";

import { useCountEntitiesToDelete } from "./hooks";

function FirstConnectionMessage({ crm, onAcknowledge }) {
  const { data, loading, hasError } = useCountEntitiesToDelete(onAcknowledge);

  if (loading) {
    return (
      <div data-test="first-crm-connection-msg-skeleton">
        <p>
          <Skeleton width="60%" />
        </p>

        <div style={{ paddingLeft: "30px", paddingBottom: "14px" }}>
          <Skeleton width="70%" />
          <Skeleton width="95%" />
          <Skeleton width="70%" />
        </div>

        <p>
          <Skeleton width="50%" />
        </p>
      </div>
    );
  }

  return (
    <div data-test="first-crm-connection-msg">
      <p style={{ margin: 0 }}>
        Prior to initiating the integration, we want to provide you with
        essential information about the upcoming process:
      </p>

      <ul>
        <li>
          Hubly will have access to your {crm} personal account information,
          including all contact records, details, comments, and tags.
        </li>
        <li>
          Please be aware that all users from your Hub will be prompted to
          connect their {crm} accounts, and access to Hubly will be temporarily
          restricted until this connection is established.
        </li>

        {(data?.totalClients > 0 || hasError) && (
          <li>
            Post-integration, please note that{" "}
            <b>{hasError ? "all" : data?.totalClients} clients</b> will no
            longer be accessible. Please make sure to make necessary copies
            before proceeding.
          </li>
        )}
      </ul>

      {(data?.totalClients > 0 || hasError) && (
        <strong>
          <Checkbox
            label={`
              I acknowledge that ${
                hasError ? "all" : data?.totalClients
              } clients
              will no longer be accessible after the integration is completed.
            `}
            onChange={() => {
              onAcknowledge((prevState) => {
                return !prevState;
              });
            }}
          />
        </strong>
      )}
    </div>
  );
}

FirstConnectionMessage.propTypes = {
  crm: PropTypes.string.isRequired,
  onAcknowledge: PropTypes.func.isRequired,
};

FirstConnectionMessage.defaultProps = {};

export default FirstConnectionMessage;
